var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid border-0 mb-0 shadow-none projectGantt" },
    [
      _c(
        "portal",
        { attrs: { to: "sidebar" } },
        [
          _c("finance", {
            attrs: {
              show: _vm.showFinance,
              fullWidth: false,
              project: _vm.project,
            },
            on: {
              outSideClicked: function ($event) {
                _vm.showFinance = false
              },
              paymentSuccess: _vm._onPaymentSuccess,
            },
          }),
          _c("approval", {
            attrs: {
              show: _vm.showApproval,
              fullWidth: false,
              project: _vm.project,
            },
            on: {
              outSideClicked: function ($event) {
                _vm.showApproval = false
              },
              approveSuccess: function ($event) {
                return _vm.$emit("approveSuccess")
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row no-gutters border row--overflow preview-box" },
        [
          _c(
            "div",
            {
              staticClass: "bg-white col-md-12 col-sm-12 border-right col-mod",
              class: { "pt-3": _vm.editMode },
            },
            [
              _c(
                "div",
                { staticClass: "table-responsive table-responsive--mod" },
                [
                  !_vm.isMobile
                    ? _c(
                        "table",
                        { staticClass: "table align-items-center table-flush" },
                        [
                          _vm._m(0),
                          _vm.openTasks
                            ? _c(
                                "tbody",
                                { staticClass: "list overflow-auto" },
                                _vm._l(_vm.openTasks, function (task, ind) {
                                  return _c(
                                    "tr",
                                    {
                                      key: ind,
                                      staticClass: "editable",
                                      class: { active: true },
                                      on: {
                                        click: function ($event) {
                                          _vm.selectedTask = task
                                        },
                                      },
                                    },
                                    [
                                      _c("td", { attrs: { scope: "row" } }, [
                                        _c(
                                          "div",
                                          { staticClass: "media-body py-2" },
                                          [
                                            _c("strong", [
                                              _vm._v(_vm._s(task.name)),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                      _c("td", { attrs: { scope: "row" } }, [
                                        _c(
                                          "div",
                                          { staticClass: "media-body py-2" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "media-body py-2",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                   " +
                                                    _vm._s(
                                                      _vm.getPreviewQuotedText(
                                                        task
                                                      ) || "No Description"
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table align-items-center table-flush border-0",
                                              },
                                              [
                                                _vm._m(1, true),
                                                _c("tbody", [
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { scope: "row" },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "media-body",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.profile
                                                                    .currency &&
                                                                    _vm.profile
                                                                      .currency
                                                                      .symbol
                                                                ) +
                                                                  "\n                              " +
                                                                  _vm._s(
                                                                    task.hourly_cost
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { scope: "row" },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "media-body",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  task.quoted_hours
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { scope: "row" },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "media-body",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  task.discount_percentage
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { scope: "row" },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "media-body",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  task.no_of_days
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { scope: "row" },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "media-body text-right total-price pr-2",
                                                          },
                                                          [
                                                            _c("h2", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getTotalCost(
                                                                    task
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "d-flex justify-content-end" }, [
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("div", { attrs: { "show-footer-line": "true" } }, [
                        _c("div", { staticClass: "card-body pr-0" }, [
                          _c("div", { staticClass: "row" }, [
                            false
                              ? _c("div", { staticClass: "col text-center" }, [
                                  _c(
                                    "h5",
                                    {
                                      staticClass:
                                        "card-title text-uppercase text-muted mb-0",
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Payment\n                    "
                                      ),
                                    ]
                                  ),
                                  _vm.project &&
                                  _vm.project.payment_status == "SUCCESS"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "h5 font-weight-bold mb-0 text-success",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-check-circle",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v(" SUCCESS"),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.project &&
                                  _vm.project.payment_status == "PENDING"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "h5 font-weight-bold mb-0 text-primary",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-user-plus",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v(" PENDING"),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.project &&
                                  _vm.project.payment_status ==
                                    "PAYER_REQUESTED"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "h5 font-weight-bold mb-0 text-primary",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-user-plus",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v(" REQUESTED"),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.project &&
                                  _vm.project.payment_status == "FAILED"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "h5 font-weight-bold mb-0 text-danger",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-times-circle",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v(" FAILED"),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            false
                              ? _c("div", { staticClass: "col text-center" }, [
                                  _c(
                                    "h5",
                                    {
                                      staticClass:
                                        "card-title text-uppercase text-muted mb-0",
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Approval\n                    "
                                      ),
                                    ]
                                  ),
                                  _vm.project &&
                                  _vm.project.approval_status == "APPROVED"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "h5 font-weight-bold mb-0 text-success",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-check-circle",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v(" APPROVED"),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.project &&
                                  _vm.project.approval_status == "QUOTED"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "h5 font-weight-bold mb-0 text-primary",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-times-circle",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v("QUOTED"),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.project &&
                                  _vm.project.approval_status == "REJECTED"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "h5 font-weight-bold mb-0 text-danger",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-times-circle",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v(" REJECTED"),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.project &&
                                  _vm.project.approval_status ==
                                    "APPROVAL_REQUESTED"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "h5 font-weight-bold mb-0 text-primary",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-user-plus",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v(" REQUESTED"),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _c("div", { staticClass: "col text-right" }, [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "card-title text-uppercase text-muted mb-0",
                                },
                                [
                                  _vm._v(
                                    "\n                      Total Cost\n                    "
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticClass: "h2 font-weight-bold mb-0" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.projectBudget.currency) +
                                      "\n                      " +
                                      _vm._s(_vm.projectBudget.cost)
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  false
                    ? _c(
                        "div",
                        { staticClass: "d-flex justify-content-end p-2 mb-2" },
                        [
                          _vm.project.payment_status == "SUCCESS" &&
                          _vm.project.approval_status != "APPROVED" &&
                          _vm.project.user_owner &&
                          _vm.project.user_owner.user.id == _vm.profile.id
                            ? _c(
                                "base-button",
                                {
                                  attrs: { size: "sm", type: "danger" },
                                  on: { click: _vm._onRequestApprovalClicked },
                                },
                                [_vm._v("Request Approval")]
                              )
                            : _vm._e(),
                          _vm.project.payment_status != "SUCCESS" &&
                          _vm.project.user_owner &&
                          _vm.project.user_owner.user.id == _vm.profile.id
                            ? _c(
                                "base-button",
                                {
                                  attrs: { size: "sm", type: "danger" },
                                  on: { click: _vm._onPaymentClicked },
                                },
                                [_vm._v("Request Approval")]
                              )
                            : _vm._e(),
                          _vm.project.payment_status != "SUCCESS" &&
                          _vm.project.financePayer &&
                          _vm.project.financePayer.user.id == _vm.profile.id
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "base-button",
                                    {
                                      attrs: { size: "sm", type: "success" },
                                      on: { click: _vm._onPaymentClicked },
                                    },
                                    [_vm._v("Proceed Payment")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.project.payment_status == "SUCCESS" &&
                          _vm.project.approver &&
                          _vm.project.approver.user.id == _vm.profile.id
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "base-button",
                                    {
                                      attrs: { size: "sm", type: "success" },
                                      on: { click: _vm._onAcceptClicked },
                                    },
                                    [_vm._v("Accept & Approve this Project")]
                                  ),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        title: "Rejection Note",
                                        placement: "bottom",
                                        width: "400",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column justify-content-end align-items-end",
                                        },
                                        [
                                          _c("html-editor", {
                                            staticClass: "w-100",
                                            model: {
                                              value: _vm.project.reject_reason,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.project,
                                                  "reject_reason",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "project.reject_reason",
                                            },
                                          }),
                                          _c(
                                            "base-button",
                                            {
                                              attrs: {
                                                size: "sm",
                                                type: "primary",
                                              },
                                              on: {
                                                click: _vm._onRejectClicked,
                                              },
                                            },
                                            [_vm._v("Submit")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "base-button",
                                        {
                                          attrs: {
                                            slot: "reference",
                                            size: "sm",
                                            type: "danger",
                                          },
                                          slot: "reference",
                                        },
                                        [_vm._v("Reject Approval")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c(
          "th",
          {
            staticClass: "py-0",
            staticStyle: { width: "300px", height: "27px" },
            attrs: { scope: "col" },
          },
          [_vm._v("\n                Task\n              ")]
        ),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "py-0", attrs: { scope: "col" } }, [
        _vm._v("\n                      Rate\n                    "),
      ]),
      _c("th", { staticClass: "py-0", attrs: { scope: "col" } }, [
        _vm._v("\n                      Hours\n                    "),
      ]),
      _c("th", { staticClass: "py-0", attrs: { scope: "col" } }, [
        _vm._v("\n                      Discount %\n                    "),
      ]),
      _c("th", { staticClass: "py-0", attrs: { scope: "col" } }, [
        _vm._v("\n                      Month\n                    "),
      ]),
      _c(
        "th",
        {
          staticClass: "py-0",
          staticStyle: { "padding-right": "10px", height: "27px" },
          attrs: { scope: "col" },
        },
        [_c("div", { staticClass: "media-body text-right" }, [_vm._v("Total")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }